"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNullableStringAGreaterThanB = isNullableStringAGreaterThanB;
exports.parseNumberFromString = parseNumberFromString;
var _stringEmptyToUndefined = require("./stringEmptyToUndefined");
/**
 * Takes only number chars from string and convert it to number. If there is no number in string, it will return 0.
 * It will return only positive number.
 * @param value string | null | undefined
 * @returns number
 */
function parseNumberFromString(value) {
  const checkedValue = (0, _stringEmptyToUndefined.stringEmptyToUndefined)(value);
  if (checkedValue === undefined) {
    return 0;
  }
  const numberValue = Number.parseFloat(checkedValue.replaceAll(/\D/g, ''));
  return Number.isNaN(numberValue) ? 0 : numberValue;
}

/**
 * Convert strings to numbers and compare them.
 * It will compare only if both numbers are 0 or greater than 0.
 * @param a string | null | undefined
 * @param b string | null | undefined
 * @returns boolean
 */
function isNullableStringAGreaterThanB(a, b) {
  const first = parseNumberFromString(a);
  const second = parseNumberFromString(b);
  if (first >= 0 && second >= 0) {
    return first > second;
  }

  // if any of strings result in 0, we consider it as false because there is no data to compare
  return false;
}
//# sourceMappingURL=stringAsNumber.js.map